import { useContext } from "react";
import { RegistrationSectionContext } from "./Context";

export const useRegistrationSection = () => {
  const context = useContext(RegistrationSectionContext);
  if (!context) {
    throw new Error('useRegistrationSection must be used within a RegistrationSection');
  }
  return context;
};